import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddAtom = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "add_atom",
	"data-name": "add atom",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 23 23",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Ellipse_520",
		"data-name": "Ellipse 520",
		fill: "none",
		stroke: "#fff",
		strokeWidth: 1,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 11.5,
			r: 11.5,
			stroke: "none"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 11.5,
			r: 11,
			fill: "none"
		})]
	}), /* @__PURE__ */ _jsx("g", {
		id: "Group_2007",
		"data-name": "Group 2007",
		transform: "translate(-21 -186.956)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Group_491",
			"data-name": "Group 491",
			transform: "translate(6591 3987)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_489",
				"data-name": "Group 489",
				transform: "translate(-6564.5 -3794.544)",
				children: [/* @__PURE__ */ _jsx("line", {
					id: "Line_34",
					"data-name": "Line 34",
					x2: 12,
					transform: "translate(0 6)",
					fill: "none",
					stroke: "#fff",
					strokeWidth: 1
				}), /* @__PURE__ */ _jsx("line", {
					id: "Line_35",
					"data-name": "Line 35",
					x2: 12,
					transform: "translate(6) rotate(90)",
					fill: "none",
					stroke: "#fff",
					strokeWidth: 1
				})]
			})
		})
	})]
});
export default SvgAddAtom;
